/* eslint-disable */
export const TYPY = {
  DILAT: "dilat",
  HPV: "hpv",
  HPVQ: "hpvq",
  INKP: "inkp",
  INKS: "inks",
  GEO: "geo",
  PRNA: "prna",
  STAB: "stab",
  MIKRO: "mikro",
  PT: "pt",
  POTRUB: "potrub",
  PEEP: "peep",
  PEES: "pees",
  MBPotrub: "mb_potrub",
  MBPT: "mb_pt",
  MBHPV: "mb_hpv",
  MBDilat: "mb_dilat",
  MBStab: "mb_stab",
  MBMikro: "mb_mikro",
  MBINK: "mb_ink",
  INSAR: "insar"
}

export function getTableURL(key) {
  let ret = ""
  switch (key) {
    case TYPY.HPV:
      ret = "/r/mer_hpv"
      break
    case TYPY.MBHPV:
      ret = "/r/mb_hpv"
      break
    case TYPY.GEO:
      ret = "/r/mer_geo"
      break
    case TYPY.HPVQ:
      ret = "/r/mer_q"
      break
    case TYPY.PRNA:
      ret = "/r/mer_prna"
      break
    case TYPY.DILAT:
      ret = "/r/mer_dilat"
      break
    case TYPY.MBDilat:
      ret = "/r/mb_dilat"
      break
    case TYPY.PEEP:
      ret = "/r/mer_peep"
      break
    case TYPY.PEES:
      ret = "/r/mer_pees"
      break
    case TYPY.POTRUB:
      ret = "/r/mer_potrub"
      break
    case TYPY.MBPotrub:
      ret = "/r/mb_potrub"
      break
    case TYPY.MIKRO:
      ret = "/r/mer_mikroniv"
      break
    case TYPY.MBMikro:
      ret = "/r/mb_mikroniv"
      break
    case TYPY.STAB:
      ret = "/r/mer_stabskal"
      break
    case TYPY.MBStab:
      ret = "/r/mb_stabskal"
      break
    case TYPY.INKP:
      ret = "/r/mer_inkp"
      break
    case TYPY.INKS:
      ret = "/r/mer_inks"
      break
    case TYPY.MBINK:
      ret = "/r/mb_ink"
      break
    case TYPY.PT:
      ret = "/r/mer_pt"
      break
    case TYPY.MBPT:
      ret = "/r/mb_pt"
      break
    case "zrazky":
      ret = "/r/zrazky"
      break
    default:
      break
  }
  return ret
}

export function getMBForBodUrl(key, bodID) {
  let ret = ""
  switch (key) {
    case TYPY.HPV:
      ret = `/r/bod/${bodID}/mb_hpv`
      break
    case TYPY.DILAT:
      ret = `/r/bod/${bodID}/mb_dilat`
      break
    case TYPY.POTRUB:
      ret = `/r/bod/${bodID}/mb_potrub`
      break
    case TYPY.MIKRO:
      ret = `/r/bod/${bodID}/mb_mikroniv`
      break
    case TYPY.STAB:
      ret = `/r/bod/${bodID}/mb_stabskal`
      break
    case TYPY.INKP:
      ret = `/r/bod/${bodID}/mb_ink`
      break
    case TYPY.INKS:
      ret = `/r/bod/${bodID}/mb_ink`
      break
    case TYPY.MBPT:
      ret = `/r/bod/${bodID}/mb_ink`
      break
    case TYPY.PT:
      ret = `/r/bod/${bodID}/mb_pt`
      break
    default:
      break
  }
  return ret
}

//getMB vracia mb typ pre typ key, ak teda existuje mb k danemu mer
export function getMB(key) {
  let ret = ""
  switch (key) {
    case TYPY.HPV:
      ret = TYPY.MBHPV
      break
    case TYPY.DILAT:
      ret = TYPY.MBDilat
      break
    case TYPY.POTRUB:
      ret = TYPY.MBPotrub
      break
    case TYPY.MIKRO:
      ret = TYPY.MBMikro
      break
    case TYPY.STAB:
      ret = TYPY.MBStab
      break
    case TYPY.INKP:
      ret = TYPY.MBINK
      break
    case TYPY.INKS:
      ret = TYPY.MBINK
      break
    case TYPY.MBPT:
      ret = TYPY.MBINK
      break
    case TYPY.PT:
      ret = TYPY.MBPT
      break
    default:
      break
  }
  return ret
}

//getHeaders vracia headers pre zoznam
export function getHeaders(key) {
  let ret = null
  switch (key) {
    case TYPY.HPV:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Hĺbka", value: "HlbkaString", align: "right" },
        { text: "Teplota", value: "TeplotaString", align: "right" },
        { text: "Typ", value: "TypMon", align: "center" }
      ]
      break
    case TYPY.MBHPV:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum Od", value: "DatumOdString", align: "right" },
        { text: "Dátum Do", value: "DatumDoString", align: "right" },
        { text: "Rúra", value: "RuraString", align: "right" },
        { text: "Píšťala", value: "PistalaString", align: "right" },
        { text: "Spôsob", value: "SposobHpv", align: "right" }
      ]
      break
    case TYPY.GEO:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "X", value: "XString", align: "right" },
        { text: "Y", value: "YString", align: "right" },
        { text: "Z", value: "ZString", align: "right" }
      ]
      break
    case TYPY.HPVQ:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Objem", value: "ObjemString", align: "right" },
        { text: "Čas naplnenia (sekundy)", value: "SecondsString", align: "right" }
      ]
      break
    case TYPY.PRNA:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Sigma 1", value: "Sigma1String", align: "right" },
        { text: "Sigma 2", value: "Sigma2String", align: "right" },
        { text: "Sigma 3", value: "Sigma3String", align: "right" },
        { text: "Sigma 4", value: "Sigma4String", align: "right" }
      ]
      break
    case TYPY.DILAT:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Teplota", value: "TeplotaString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.MBDilat:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum Od", value: "DatumOdString", align: "right" },
        { text: "Dátum Do", value: "DatumDoString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.PEEP:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Hĺbka", value: "HlbkaString", align: "right" },
        { text: "P1", value: "P1String", align: "right" },
        { text: "P2", value: "P2String", align: "right" },
        { text: "P3", value: "P3String", align: "right" }
      ]
      break
    case TYPY.PEES:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Interval", value: "IntervalString", align: "right" },
        { text: "Hĺbka od", value: "HlbkaOdString", align: "right" },
        { text: "Hĺbka do", value: "HlbkaDoString", align: "right" },
        { text: "Pee", value: "PeeString", align: "right" }
      ]
      break
    case TYPY.POTRUB:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Etapa", value: "EtapaString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.MBPotrub:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum Od", value: "DatumOdString", align: "right" },
        { text: "Dátum Do", value: "DatumDoString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.MIKRO:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Teplota", value: "TeplotaString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.MBMikro:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum Od", value: "DatumOdString", align: "right" },
        { text: "Dátum Do", value: "DatumDoString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.STAB:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Teplota", value: "TeplotaString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.MBStab:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum Od", value: "DatumOdString", align: "right" },
        { text: "Dátum Do", value: "DatumDoString", align: "right" },
        { text: "Etalón", value: "Etalon", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.MBINK:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum Od", value: "DatumOdString", align: "right" },
        { text: "Dátum Do", value: "DatumDoString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.INKP:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Hĺbka", value: "HlbkaString", align: "right" },
        { text: "Hodnota A", value: "MAString", align: "right" },
        { text: "Hodnota B", value: "MBString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.INKS:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Indikatív", value: "Ind", align: "left" },
        { text: "Hodnota A", value: "MAString", align: "right" },
        { text: "Hodnota B", value: "MBString", align: "right" },
        { text: "Teplota A", value: "TAString", align: "right" },
        { text: "Teplota B", value: "TBString", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.MBPT:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum Od", value: "DatumOdString", align: "right" },
        { text: "Dátum Do", value: "DatumDoString", align: "right" },
        { text: "Indikatív", value: "ind", align: "left" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break
    case TYPY.PT:
      ret = [
        { text: "ID", value: "ID", align: "left" },
        { text: "Dátum", value: "DatumString", align: "right" },
        { text: "Hodnota 1", value: "P1String", align: "right" },
        { text: "Hodnota 2", value: "P2String", align: "right" },
        { text: "Teplota 1", value: "Teplota1String", align: "right" },
        { text: "Teplota 2", value: "Teplota2String", align: "right" },
        { text: "Poznámka", value: "Poznamka", align: "left" }
      ]
      break

    default:
      break
  }
  return ret
}

export function getTypItems(key) {
  let ret = null
  switch (key) {
    case TYPY.HPV:
      ret = [
        { text: "Dátum", value: "Datum", width: "4", typ: "datetime" },
        { text: "Hĺbka", value: "Hlbka", width: "4", typ: "number" },
        { text: "Teplota", value: "Teplota", width: "4", typ: "number" },
        { text: "Typ", value: "TypMon", width: "4", typ: "text", maxlength: 1 },
        { text: "Kód", value: "KodP", width: "4", typ: "text", maxlength: 1 },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MBHPV:
      ret = [
        { text: "Dátum Od", value: "DatumOd", width: "3", typ: "datetime" },
        { text: "Dátum Do", value: "DatumDo", width: "3", typ: "datetime" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" },
        { text: "Rúra", value: "Rura", width: "3", typ: "number" },
        { text: "Píšťala", value: "Pistala", width: "3", typ: "number" },
        { text: "Spôsob hpv", value: "SposobHpv", width: "3", typ: "text", maxlength: 255 },
        { text: "Indikatív hladinometra ", value: "Indik", width: "3", typ: "text", maxlength: 4 }
      ]
      break
    case TYPY.GEO:
      ret = [
        { text: "Dátum", value: "Datum", width: "3", typ: "datetime" },
        { text: "X", value: "X", width: "3", typ: "number" },
        { text: "Y", value: "Y", width: "3", typ: "number" },
        { text: "Z", value: "Z", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.HPVQ:
      ret = [
        { text: "Dátum", value: "Datum", width: "4", typ: "datetime" },
        { text: "Objem", value: "Objem", width: "4", typ: "number" },
        { text: "Čas naplnenia (sekundy)", value: "Seconds", width: "4", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.PRNA:
      ret = [
        { text: "Dátum", value: "Datum", width: "4", typ: "datetime" },
        { text: "Sigma 1", value: "Sigma1", width: "2", typ: "number" },
        { text: "Sigma 2", value: "Sigma2", width: "2", typ: "number" },
        { text: "Sigma 3", value: "Sigma3", width: "2", typ: "number" },
        { text: "Sigma 4", value: "Sigma4", width: "2", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.DILAT:
      ret = [
        { text: "Dátum", value: "Datum", width: "6", typ: "datetime" },
        { text: "Teplota", value: "Teplota", width: "6", typ: "number" },
        { text: "Došlo k prestaveniu pristroja", value: "Zmena", width: "3", typ: "boolean" },
        { text: "Meranie nadväzuje na predchádzajúcu hodnotu", value: "Vazba", width: "3", typ: "boolean" },
        { text: "Merané na vertikálnom kruhu", value: "Verzap", width: "3", typ: "boolean" },
        { text: "Merané na horizontálnom kruhu", value: "Horzap", width: "3", typ: "boolean" },
        { text: "Čítanie na veľkom kruhu (vertikálny kruh)", value: "Vvc", width: "3", typ: "number" },
        { text: "Čítanie na malom kruhu (vertikálny kruh)", value: "Vmc", width: "3", typ: "number" },
        { text: "Odčítanie smeru pohybu v grádoch (vertikálny kruh)", value: "Vsmer", width: "3", typ: "number" },
        { text: "Odčítanie hodnoty rotácie v smere R200 v cm", value: "Vr200", width: "3", typ: "number" },
        { text: "Dĺžka plochy odčítania rotácie v smere R200 (vertikálny kruh)", value: "Vr200d", width: "3", typ: "number" },
        { text: "Odčítanie hodnoty rotácie v smere R300 v cm (vertikálny kruh)", value: "Vr300", width: "3", typ: "number" },
        { text: "Dĺžka plochy odčítania rotácie v smere R300 (vertikálny kruh)", value: "Vr300d", width: "3", typ: "number" },
        { text: "Čítanie na veľkom kruhu (horizontálny kruh)", value: "Hvc", width: "3", typ: "number" },
        { text: "Čítanie na malom kruhu (horizontálny kruh)", value: "Hmc", width: "3", typ: "number" },
        { text: "Odčítanie smeru pohybu v grádoch (horizontálny kruh)", value: "Hsmer", width: "3", typ: "number" },
        { text: "Odčítanie hodnoty rotácie v smere R200 v cm (horizontálny kruh)", value: "Hr200", width: "3", typ: "number" },
        { text: "Dĺžka plochy odčítania rotácie v smere R200 (horizontálny kruh)", value: "Hr200d", width: "3", typ: "number" },
        { text: "Odčítanie hodnoty rotácie v smere R300 v cm (horizontálny kruh)", value: "Hr300", width: "3", typ: "number" },
        { text: "Dĺžka plochy odčítania rotácie v smere R300 (horizontálny kruh)", value: "Hr300d", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MBDilat:
      ret = [
        { text: "Dátum Od", value: "DatumOd", width: "3", typ: "datetime" },
        { text: "Dátum Do", value: "DatumDo", width: "3", typ: "datetime" },
        { text: "Smer sklonu pukliny", value: "Gs", width: "3", typ: "number" },
        { text: "Sklon pukliny", value: "Fs", width: "3", typ: "number" },
        { text: "Smer sklonu prístroja", value: "Gx", width: "3", typ: "number" },
        { text: "Sklon prístroja", value: "Fx", width: "3", typ: "number" },
        { text: "Počet čiar na 1mm na interfer. obrazci rotácií", value: "Ir", width: "3", typ: "number" },
        { text: "Počet kružníc na 1mm na int. obrazci veľk.kruhu", value: "Ikv", width: "3", typ: "number" },
        { text: "Počet kružníc na 1mm na int. obrazci mal.kruhu", value: "Ikm", width: "3", typ: "number" },
        { text: "Dĺžka konzoly v smere X-ovej osi v mm", value: "Dkx", width: "3", typ: "number" },
        { text: "Dĺžka konzoly v smere Y-ovej osi v mm", value: "Dky", width: "3", typ: "number" },
        { text: "Dĺžka konzoly v smere Z-ovej osi v mm", value: "Dkz", width: "3", typ: "number" },
        { text: "Smerovanie osi x", value: "Xhore", width: "3", typ: "boolean" },
        { text: "Smerovanie osi z", value: "Zhore", width: "3", typ: "boolean" },
        { text: "Ľavotočivá sústava", value: "Lavotoc", width: "3", typ: "boolean" },
        { text: "Má meranie rotácií", value: "Rot", width: "3", typ: "boolean" },
        { text: "Smer x ide do masívu", value: "Xmas", width: "3", typ: "boolean" },
        { text: "Na prístroji je malý kruh", value: "Malk", width: "3", typ: "boolean" },
        { text: "Konštanta tepelnej rozťažnosti konzol", value: "Ct", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.PEEP:
      ret = [
        { text: "Dátum", value: "Datum", width: "4", typ: "datetime" },
        { text: "Hĺbka", value: "Hlbka", width: "2", typ: "number" },
        { text: "P1", value: "P1", width: "2", typ: "number" },
        { text: "P2", value: "P2", width: "2", typ: "number" },
        { text: "P3", value: "P3", width: "2", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.PEES:
      ret = [
        { text: "Dátum", value: "Datum", width: "4", typ: "datetime" },
        { text: "Interval", value: "Interval", width: "2", typ: "number" },
        { text: "Hĺbka od", value: "HlbkaOd", width: "2", typ: "number" },
        { text: "Hĺbka do", value: "HlbkaDo", width: "2", typ: "number" },
        { text: "Pee", value: "Pee", width: "2", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.POTRUB:
      ret = [
        { text: "Dátum", value: "Datum", width: "3", typ: "datetime" },
        { text: "Etapa", value: "Etapa", width: "3", typ: "number" },
        { text: "Teplota vzduchu", value: "TeplotaV", width: "3", typ: "number" },
        { text: "Výška nadložia", value: "VyskaN", width: "3", typ: "number" },
        { text: "Prvé vertikálne meranie", value: "Mv1", width: "3", typ: "number" },
        { text: "Druhé vertikálne meranie", value: "Mv2", width: "3", typ: "number" },
        { text: "Prvé horizontálne meranie", value: "Mh1", width: "3", typ: "number" },
        { text: "Druhé horizontálne meranie", value: "Mh2", width: "3", typ: "number" },
        { text: "Teplota potrubia 1. meranie", value: "Teplota1", width: "6", typ: "number" },
        { text: "Teplota potrubia 2. meranie", value: "Teplota2", width: "6", typ: "number" },
        { text: "Kontrola dutín 1", value: "Kontrol1", width: "3", typ: "text", maxlength: 255 },
        { text: "Kontrola dutín 2", value: "Kontrol2", width: "3", typ: "text", maxlength: 255 },
        { text: "Kontrola dutín 3", value: "Kontrol3", width: "3", typ: "text", maxlength: 255 },
        { text: "Kontrola dutín 4", value: "Kontrol4", width: "3", typ: "text", maxlength: 255 },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MBPotrub:
      ret = [
        { text: "Dátum Od", value: "DatumOd", width: "4", typ: "datetime" },
        { text: "Dátum Do", value: "DatumDo", width: "4", typ: "datetime" },
        { text: "Názov potrubia", value: "Nazov", width: "4", typ: "text", maxlength: 255 },
        { text: "Názov meraného stanovišťa", value: "Stanov", width: "3", typ: "text", maxlength: 255 },
        { text: "Staničenie", value: "Stanic", width: "3", typ: "number" },
        { text: "Základné meranie vo vertikálnom smere", value: "ZakladV", width: "3", typ: "number" },
        { text: "Základné meranie v horizontálnom smere", value: "ZakladH", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MIKRO:
      ret = [
        { text: "Dátum", value: "Datum", width: "6", typ: "datetime" },
        { text: "Teplota", value: "Teplota", width: "6", typ: "number" },
        { text: "Meranie bodu 1 v profile (mm)", value: "M1", width: "3", typ: "number" },
        { text: "Meranie bodu 2 v profile (mm)", value: "M2", width: "3", typ: "number" },
        { text: "Meranie bodu 3 v profile (mm)", value: "M3", width: "3", typ: "number" },
        { text: "Meranie bodu 4 v profile (mm)", value: "M4", width: "3", typ: "number" },
        { text: "Meranie bodu 5 v profile (mm)", value: "M5", width: "3", typ: "number" },
        { text: "Meranie bodu 6 v profile (mm)", value: "M6", width: "3", typ: "number" },
        { text: "Meranie bodu 7 v profile (mm)", value: "M7", width: "3", typ: "number" },
        { text: "Meranie bodu 8 v profile (mm)", value: "M8", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MBMikro:
      ret = [
        { text: "Dátum Od", value: "DatumOd", width: "3", typ: "datetime" },
        { text: "Dátum Do", value: "DatumDo", width: "3", typ: "datetime" },
        { text: "Dĺžka etalónu v mm", value: "Etalon", width: "3", typ: "number" },
        { text: "Kód monitorovacieho bodu pre výpočet dilatácie", value: "StacioMb", width: "3", typ: "text", maxlength: 10 },
        { text: "Litológia 1", value: "LitolM1", width: "3", typ: "text", maxlength: 20 },
        { text: "Litológia 2", value: "LitolM2", width: "3", typ: "text", maxlength: 20 },
        { text: "Litológia 3", value: "LitolM3", width: "3", typ: "text", maxlength: 20 },
        { text: "Litológia 4", value: "LitolM4", width: "3", typ: "text", maxlength: 20 },
        { text: "Litológia 5", value: "LitolM5", width: "3", typ: "text", maxlength: 20 },
        { text: "Litológia 6", value: "LitolM6", width: "3", typ: "text", maxlength: 20 },
        { text: "Litológia 7", value: "LitolM7", width: "3", typ: "text", maxlength: 20 },
        { text: "Litológia 8", value: "LitolM8", width: "3", typ: "text", maxlength: 20 },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.STAB:
      ret = [
        { text: "Dátum", value: "Datum", width: "6", typ: "datetime" },
        { text: "Rozmer etalónu (mm)", value: "EtalRozm", width: "3", typ: "number" },
        { text: "Teplota vzduchu pri meraní", value: "Teplota", width: "3", typ: "number" },
        { text: "Odpočet hodnoty etalónu pri nule (1. meranie)", value: "E01", width: "4", typ: "number" },
        { text: "Odpočet hodnoty etalónu pri nule (2. meranie)", value: "E02", width: "4", typ: "number" },
        { text: "Odpočet hodnoty etalónu pri nule (3. meranie)", value: "E03", width: "4", typ: "number" },
        { text: "Odpočet hodnoty etalónu pri určenom rozmere (1. meranie)", value: "EMax1", width: "3", typ: "number" },
        { text: "Odpočet hodnoty etalónu pri určenom rozmere (2. meranie)", value: "EMax2", width: "3", typ: "number" },
        { text: "Odpočet hodnoty etalónu pri určenom rozmere (3. meranie)", value: "EMax3", width: "3", typ: "number" },
        { text: "Hodnota prepočtu pre dĺžku etalónu", value: "Ciach", width: "3", typ: "number" },
        { text: "Meranie LD1", value: "MerLd1", width: "4", typ: "number" },
        { text: "Meranie LD2", value: "MerLd2", width: "4", typ: "number" },
        { text: "Meranie LD3", value: "MerLd3", width: "4", typ: "number" },
        { text: "Meranie PH1", value: "MerPh1", width: "4", typ: "number" },
        { text: "Meranie PH2", value: "MerPh2", width: "4", typ: "number" },
        { text: "Meranie PH3", value: "MerPh3", width: "4", typ: "number" },
        { text: "Dilat vzd", value: "DilatVzd", width: "3", typ: "number" },
        { text: "Stacio vzd", value: "StacioVzd", width: "3", typ: "number" },
        { text: "Dilat stc", value: "DilatStc", width: "3", typ: "number" },
        { text: "Dilat tpl", value: "DilatTpl", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MBStab:
      ret = [
        { text: "Dátum Od", value: "DatumOd", width: "6", typ: "datetime" },
        { text: "Dátum Do", value: "DatumDo", width: "6", typ: "datetime" },
        { text: "Dĺžka etalónu v mm", value: "Etalon", width: "6", typ: "number" },
        { text: "Kód monitorovacieho bodu pre prepočet dilatácie", value: "StacioMb", width: "6", typ: "text", maxlength: 255 },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MBINK:
      ret = [
        { text: "Dátum Od", value: "DatumOd", width: "3", typ: "datetime" },
        { text: "Dátum Do", value: "DatumDo", width: "3", typ: "datetime" },
        { text: "Azimut", value: "Azimut", width: "3", typ: "number" },
        { text: "Hĺbka inštalácie sondy", value: "HlbkaInc", width: "3", typ: "number" },
        { text: "Sériové číslo sondy inštalovanej do smeru x", value: "XSeriaN", width: "3", typ: "text", maxlength: 255 },
        { text: "Hodnota v smere osi x počas inštalácie", value: "XInstalR", width: "3", typ: "number" },
        { text: "Teplota počas inštalácie inklinometra - X", value: "XInstalT", width: "3", typ: "number" },
        { text: "Faktor lineárneho merania (X)", value: "XFaktorG", width: "3", typ: "number" },
        { text: "Sériové číslo sondy inštalovanej do smeru y", value: "YSeriaN", width: "3", typ: "text", maxlength: 255 },
        { text: "Hodnota v smere osi y počas inštalácie", value: "YInstalR", width: "3", typ: "number" },
        { text: "Teplota počas inštalácie inklinometra - Y", value: "YInstalT", width: "3", typ: "number" },
        { text: "Faktor lineárneho merania (Y)", value: "YFaktorG", width: "3", typ: "number" },
        { text: "Typ (s - stacionárny, p - prenosný, t - pórové tlaky)", value: "Typ", width: "6", typ: "text", maxlength: 1 },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.INKP:
      ret = [
        { text: "Dátum", value: "Datum", width: "3", typ: "datetime" },
        { text: "Hĺbka meraného horizontu od ústia pažnice", value: "Hlbka", width: "3", typ: "number" },
        { text: "Nameraná hodnota v smere osi x", value: "MA", width: "3", typ: "number" },
        { text: "Nameraná hodnota v smere osi y", value: "MB", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.INKS:
      ret = [
        { text: "Dátum", value: "Datum", width: "6", typ: "datetime" },
        { text: "Indikatív prenosného zariadenia", value: "Ind", width: "6", typ: "text", maxlength: 255 },
        { text: "Nameraná hodnota v smere osi x", value: "MA", width: "3", typ: "number" },
        { text: "Nameraná hodnota v smere osi y", value: "MB", width: "3", typ: "number" },
        { text: "Nameraná teplota v smere osi x", value: "TA", width: "3", typ: "number" },
        { text: "Nameraná teplota v smere osi y", value: "TB", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.MBPT:
      ret = [
        { text: "Dátum Od", value: "DatumOd", width: "3", typ: "datetime" },
        { text: "Dátum Do", value: "DatumDo", width: "3", typ: "datetime" },
        { text: "Indikatív zariadenia", value: "Ind", width: "6", typ: "text", maxlength: 255 },
        { text: "Dátum inštalácie - 1", value: "P1Datum", width: "3", typ: "datetime" },
        { text: "Hĺbka inštalácie - 1", value: "P1Hlbka", width: "3", typ: "number" },
        { text: "Sériové číslo - 1", value: "P1SeriaN", width: "6", typ: "text", maxlength: 255 },
        { text: "Hodnota počas inštalácie 1", value: "P1InstalR", width: "3", typ: "number" },
        { text: "Teplota počas inštalácie 1", value: "P1InstalT", width: "3", typ: "number" },
        { text: "Faktor lineárneho merania 1", value: "P1FaktorG", width: "3", typ: "number" },
        { text: "Teplotný faktor 1", value: "P1FaktorK", width: "3", typ: "number" },
        { text: "Dátum inštalácie 2", value: "P2Datum", width: "3", typ: "datetime" },
        { text: "Hĺbka inštalácie 2", value: "P2Hlbka", width: "3", typ: "number" },
        { text: "Sériové číslo 2", value: "P2SeriaN", width: "6", typ: "text", maxlength: 255 },
        { text: "Hodnota počas inštalácie 2", value: "P2InstalR", width: "3", typ: "number" },
        { text: "Teplota počas inštalácie 2", value: "P2InstalT", width: "3", typ: "number" },
        { text: "Faktor lineárneho merania 2", value: "P2FaktorG", width: "3", typ: "number" },
        { text: "Teplotný faktor 2", value: "P2FaktorK", width: "3", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case TYPY.PT:
      ret = [
        { text: "Dátum", value: "Datum", width: "12", typ: "datetime" },
        { text: "Hodnota 1", value: "P1", width: "6", typ: "number" },
        { text: "Hodnota 2", value: "P2", width: "6", typ: "number" },
        { text: "Teplota 1", value: "Teplota1", width: "6", typ: "number" },
        { text: "Teplota 2", value: "Teplota2", width: "6", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    case "zrazky":
      ret = [
        { text: "Dátum", value: "Datum", width: "12", typ: "datetime" },
        { text: "Typ (D - denné, M - mesačné)", value: "Typ", width: "6", typ: "text", maxlength: 1 },
        { text: "Zrážky", value: "Zrazky", width: "6", typ: "number" },
        { text: "Priemerná teplota", value: "TeplotaP", width: "6", typ: "number" },
        { text: "Max.teplota", value: "TeplotaMax", width: "6", typ: "number" },
        { text: "Min.teplota", value: "TeplotaMin", width: "6", typ: "number" },
        { text: "Mraz.dní", value: "PocetM", width: "6", typ: "number" },
        { text: "Poznámka", value: "Poznamka", width: "12", typ: "textarea" }
      ]
      break
    default:
      break
  }
  return ret
}

export function getTableName(key) {
  let ret = ""
  switch (key) {
    case TYPY.DILAT:
      ret = "dilat"
      break
    case TYPY.GEO:
      ret = "geo"
      break
    case TYPY.HPV:
      ret = "hpv"
      break
    case TYPY.INKP:
      ret = "inkp"
      break
    case TYPY.INKS:
      ret = "inks"
      break
    case TYPY.MIKRO:
      ret = "mikroniv"
      break
    case TYPY.PEEP:
      ret = "peep"
      break
    case TYPY.PEES:
      ret = "pees"
      break
    case TYPY.POTRUB:
      ret = "potrub"
      break
    case TYPY.PRNA:
      ret = "prn"
      break
    case TYPY.PT:
      ret = "pt"
      break
    case TYPY.HPVQ:
      ret = "q"
      break
    case TYPY.STAB:
      ret = "stabskal"
      break
    default:
      ret = key
      break
  }
  return ret
}

export function getDescription(key) {
  let ret = ""
  switch (key) {
    case TYPY.DILAT:
      ret = "Dilatometrické meranie TM - 71"
      break
    case TYPY.HPV:
      ret = "Meranie hladiny podzemnej vody"
      break
    case TYPY.HPVQ:
      ret = "Meranie prietokov"
      break
    case TYPY.INKP:
      ret = "Inklinometrické merania, prenosný variant"
      break
    case TYPY.INKS:
      ret = "Inklinometrické merania, stacionárny variant"
      break
    case TYPY.GEO:
      ret = "Geodetické merania"
      break
    case TYPY.PRNA:
      ret = "Meranie povrchových reziduálnych napätí"
      break
    case TYPY.STAB:
      ret = "Meranie posunov skalných blokov"
      break
    case TYPY.MIKRO:
      ret = "Mikromorfologické meranie"
      break
    case TYPY.PT:
      ret = "Meranie pórových tlakov"
      break
    case TYPY.POTRUB:
      ret = "Meranie rozmerových zmien potrubia"
      break
    case TYPY.PEEP:
      ret = "PEE meranie, primárne záznamy"
      break
    case TYPY.PEES:
      ret = "PEE meranie, sekundárne záznamy"
      break
    case TYPY.MBINK:
      ret = "Inklinometria – body, stacionárna metóda"
      break
    case TYPY.MBPT:
      ret = "Pórové tlaky – body"
      break
    case TYPY.MBDilat:
      ret = "Dilatometrická metóda TM - 71 – body"
      break
    case TYPY.MBHPV:
      ret = "Hladina podzemnej vody – body"
      break
    case TYPY.MBPotrub:
      ret = "Zmeny potrubia – body"
      break
    case TYPY.MBMikro:
      ret = "Mikromorfologické zmeny – body"
      break
    case TYPY.MBStab:
      ret = "Dilatometrická metóda – body"
      break
    default:
      console.error("getDescription, unknown KEY:" + key)
      break
  }
  return ret
}

/*
insar – InSAR dráha
insar_bod – InSAR body
insar_mer – InSAR merania
net3d – fotogrametria, LIDAR
mer_net3d – fotogrametrické meranie, LIDAR meranie
*/

export function getMeranieCountItem(lokalita, meranie) {
  let ret = { iconName: "", text: "" }
  switch (meranie) {
    case TYPY.INKP:
      if (lokalita.InkpsCount > 0) {
        ret = {
          iconName: "mdi-sign-direction",
          text: "Inklinometria prenosná",
          pocet: lokalita.InkpsCount
        }
      }
      break
    case TYPY.INKS:
      if (lokalita.InkssCount > 0) {
        ret = {
          iconName: "mdi-sign-direction",
          text: "Inklinometria stacionárna",
          pocet: lokalita.InkssCount
        }
      }
      break
    case TYPY.PT:
      if (lokalita.PTsCount > 0) {
        ret = {
          iconName: "mdi-wiper",
          text: "Pórových tlakov",
          pocet: lokalita.PTsCount
        }
      }
      break
    case TYPY.DILAT:
      if (lokalita.DilatsCount > 0) {
        ret = {
          iconName: "mdi-slope-uphill",
          text: "Dilatometrické - skalné bloky",
          pocet: lokalita.DilatsCount
        }
      }
      break
    case TYPY.HPV:
      if (lokalita.HpvsCount > 0) {
        ret = {
          iconName: "mdi-waves",
          text: "Hladiny podz.vody",
          pocet: lokalita.HpvsCount
        }
      }
      break
    case TYPY.POTRUB:
      if (lokalita.PotrubsCount > 0) {
        ret = {
          iconName: "mdi-arrow-collapse-vertical",
          text: "Pr.rozm.zmien potrubia",
          pocet: lokalita.PotrubsCount
        }
      }
      break
    case TYPY.MIKRO:
      if (lokalita.MikrosCount > 0) {
        ret = {
          iconName: "mdi-microscope",
          text: "Mikromorfologické",
          pocet: lokalita.MikrosCount
        }
      }
      break
    case TYPY.STAB:
      if (lokalita.StabsCount > 0) {
        ret = {
          iconName: "mdi-arrow-collapse-horizontal",
          text: "Dilatometrické",
          pocet: lokalita.StabsCount
        }
      }
      break
    case TYPY.GEO:
      if (lokalita.GeosCount > 0) {
        ret = {
          iconName: "mdi-crosshairs-gps",
          text: "Geodetické",
          pocet: lokalita.GeosCount
        }
      }
      break
    case TYPY.HPVQ:
      if (lokalita.HpvqsCount > 0) {
        ret = {
          iconName: "mdi-arrow-split-horizontal",
          text: "Prietokov",
          pocet: lokalita.HpvqsCount
        }
      }
      break
    case TYPY.PEEP:
      if (lokalita.PEEPsCount > 0) {
        ret = {
          iconName: "mdi-clipboard-pulse",
          text: "PEE - primárne",
          pocet: lokalita.PEEPsCount
        }
      }
      break
    case TYPY.PEES:
      if (lokalita.PEESsCount > 0) {
        ret = {
          iconName: "mdi-pulse",
          text: "PEE - sekundárne",
          pocet: lokalita.PEESsCount
        }
      }
      break
    case TYPY.PRNA:
      if (lokalita.PRNAsCount > 0) {
        ret = {
          iconName: "mdi-publish",
          text: "Povrchové reziduálne",
          pocet: lokalita.PRNAsCount
        }
      }
      break
    case TYPY.INSAR:
      if (lokalita.INSARCount > 0) {
        ret = {
          iconName: "mdi-satellite",
          text: "InSAR",
          pocet: lokalita.INSARCount
        }
      }
      break

    default:
      break
  }
  return ret
}
